import { useState } from "react";
import { NavLink } from "react-router-dom";

import "../css/header.css";
import image1 from "../img/utpl.png";

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <div className="wrapper-header">
      <div className="layout9">
        
        {/* LOGO */}
        <div className="logo">
          <NavLink to="/">
            <img src={image1} alt="utpl" className="logo" />
          </NavLink>
        </div>

        {/* BOTÓN HAMBURGUESA */}
        <div 
          className={`hamburger ${open ? "active" : ""}`} 
          onClick={() => setOpen(!open)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* MENÚ */}
        <div className={`menu-items ${open ? "open" : ""}`}>
          <a href="#tematica" onClick={() => setOpen(false)}>Líneas temáticas</a>
          <a href="#sede" onClick={() => setOpen(false)}>Sede</a>
          <a href="#agenda" onClick={() => setOpen(false)}>Agenda</a>
          <a href="#loja" onClick={() => setOpen(false)}>Loja</a>
          <a href="#hotel" onClick={() => setOpen(false)}>Hospedaje</a>
          <a className="btn-primary bg-gold" href="#inscripcion" onClick={() => setOpen(false)}>Inscripción</a>
              
        </div>

      </div>
    </div>
  );
}

export default Header;